package com.example.crashbit

import kotlin.time.TimeSource

private val startMark = TimeSource.Monotonic.markNow()

fun currentTimeMillis(): Long = startMark.elapsedNow().inWholeMilliseconds
fun currentTimeNanos(): Long = startMark.elapsedNow().inWholeNanoseconds
